import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Section } from "@roqua/components/sections";

import { StopButton } from "@/components/ProtocolSubscriptions/StopButton";
import { graphql } from "@/gql";
import { ProtocolSubscriptionStatusEnum } from "@/gql/graphql";
import { useVerifiedSession } from "@/session";
import { ErrorPage } from "@/components/ErrorPage";
import { toError } from "@/lib/utils";

const Query = graphql(/* GraphQL */ `
  query protocolSubscriptionPage($respondentId: ID!, $protocolSubscriptionId: ID!) {
    respondent(id: $respondentId) {
      protocolSubscription(id: $protocolSubscriptionId) {
        id
        status
        autoProtocol {
          id
          name
        }
      }
    }
  }
`);

export const Route = createFileRoute("/portal/protocol_subscriptions/$protocolSubscriptionId/stop")(
  {
    component: RouteComponent,
    errorComponent: ({ error }) => <ErrorPage message={toError(error).message} />
  },
);

function RouteComponent() {
  const { client, user } = useVerifiedSession();
  const params = Route.useParams();

  const {
    data: { respondent },
  } = useSuspenseQuery({
    queryKey: ["ProtocolSubscriptionStop"],
    queryFn: () =>
      client.request(Query, {
        respondentId: user.id,
        protocolSubscriptionId: params.protocolSubscriptionId,
      }),
  });

  return (
    <>
      <Section variant="header">
        <header className="text-xl">
          <p>
            Protocol &ldquo;{respondent.protocolSubscription.autoProtocol.name}&rdquo; stopzetten?
          </p>
        </header>
      </Section>
      <Section variant="content">
        <div className="space-y-4">
          <p>
            Hier kun je het automatisch protocol waarop je geabonneerd bent stopzetten. Je krijgt
            dan geen uitnodigingen meer om de vragenlijsten die hierbij horen in te vullen.
          </p>
          <p>
            Voordat je dat doet willen we graag benadrukken dat deze vragenlijsten heel belangrijk
            zijn voor het verbeteren van jouw zorg en welzijn. Met jouw antwoorden kan je
            behandelaar jouw klachten en hoe je je voelt beter begrijpen. Zo kan je behandelaar zien
            hoe het met je gaat en hoe goed de behandeling voor jou werkt. Door de vragenlijsten in
            te vullen help je ons om samen te werken aan jouw behandeling.
          </p>
          <p>
            We begrijpen dat het niet altijd leuk is om vragenlijsten in te vullen, maar ze zijn
            echt belangrijk voor jouw behandeling. We raden je daarom aan om eerst met je
            behandelaar te overleggen. Als je toch dit automatisch protocol nu wilt stopzetten, klik
            dan op de onderstaande knop. Jouw behandelaar zal hier een bericht van krijgen. Het
            betekent ook niet dat je helemaal geen uitnodigingen meer zal krijgen om vragenlijsten
            in te vullen.
          </p>
          <p>Als je vragen hebt, kun je altijd contact opnemen met je behandelaar.</p>
        </div>
        <div className="space-x-2">
          <StopButton
            protocolSubscriptionId={respondent.protocolSubscription.id}
            active={isActive(respondent.protocolSubscription.status)}
          />
        </div>
      </Section>
    </>
  );
}

function isActive(status: ProtocolSubscriptionStatusEnum) {
  return [
    ProtocolSubscriptionStatusEnum.Scheduled,
    ProtocolSubscriptionStatusEnum.Started,
  ].includes(status);
}
